import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgChevronDownIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M36.932 40.398a3.2 3.2 0 0 1-2.499 1.201h-4.862a3.2 3.2 0 0 1-2.498-1.2l-12.32-15.4L17.252 23l12.32 15.4h4.861L46.753 23l2.499 1.999z"
    />
  </svg>
)
export default SvgChevronDownIcon
